import { Colors, IcAddress, IcClose, IcOnline, IcPhone, IcInStore, Text, IcScreen, Row, IcAccount } from 'basic-ui-lib';
import storeSelectors from 'modules/store/services/selectors';
import { ScreenStatus } from 'modules/dashboard/services/constants';
import styled from 'styled-components';
import { IDetailStore } from 'modules/store/interfaces/api';
import DashboardStatItemMobile from './DashboardStatItemMobile';

interface StoreInfoMobileProps {
  detailStore: IDetailStore | null;
}

const StoreInfoMobile = ({ detailStore }: StoreInfoMobileProps) => {
  const screenList = storeSelectors.getScreenListInStore();
  const onlineCount = screenList?.content?.filter((s) => s.status === ScreenStatus.ONLINE).length ?? 0;
  const offlineCount =
    screenList?.content?.filter((s) => s.status === ScreenStatus.OFFLINE || s.status === ScreenStatus.DEACTIVATED)
      .length ?? 0;

  return (
    <Container>
      <HeaderSection>
        <AvatarBox>
          <IcInStore width={28} height={28} fill={Colors.neutral.bg[1]} />
        </AvatarBox>
        <NameGroup>
          <Text title_h5 semibold left>
            {`${detailStore?.firstName} ${detailStore?.lastName}` || '—'}
          </Text>
          <Row>
            <IcAccount width={12} height={12} fill={Colors.neutral.text[3]} />
            <Text body_1 medium color='neutral.text.3'>
              {detailStore?.businessName || '—'}
            </Text>
          </Row>
          <Row>
            <IcPhone width={12} height={12} fill={Colors.neutral.text[3]} />
            <Text caption_3 regular>
              {detailStore?.phone || '—'}
            </Text>
          </Row>
          <Row>
            <IcAddress width={12} height={12} fill={Colors.neutral.text[3]} />
            <Text caption_3 regular>
              {detailStore?.address || '—'}
            </Text>
          </Row>
        </NameGroup>
              </HeaderSection>
                <StatsGroup>
          <DashboardStatItemMobile
            label='TOTAL'
            value={0}
            icon={<IcScreen width={20} height={20} fill={Colors.primary[6]} />}
            colorValue='neutral.text.5'
          />
          <DashboardStatItemMobile
            label='ONLINE'
            value={onlineCount}
            icon={<IcOnline width={20} height={20} fill={Colors.secondary[5]} />}
            colorValue='secondary.5'
          />
          <DashboardStatItemMobile
            label='OFFLINE'
            value={offlineCount}
            icon={<IcClose fill={Colors.other[3]} width={20} height={20} />}
            colorValue='other.3'
          />
        </StatsGroup>
    </Container>
  );
};

export default StoreInfoMobile;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

const HeaderSection = styled.div`
  display: flex;

  align-items: flex-start;
  gap: 16px;
`;

const AvatarBox = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: ${Colors.primary[5]};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const NameGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const StatsGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
`;
